// extracted by mini-css-extract-plugin
module.exports = {"emailSideTab":"az_C3","expanded":"az_D3","disappear":"az_E3"};